import axios from "axios";
import { jwtDecode } from "jwt-decode";

const AUTH_EXPIRED_GUARD_KEY = "portal_auth_expired_redirecting";

export const getStoredAuthToken = () =>
  localStorage.getItem("jwtToken") ||
  localStorage.getItem("authToken") ||
  sessionStorage.getItem("token") ||
  "";

export const clearAuthStorage = () => {
  const brand = localStorage.getItem("brand");

  localStorage.removeItem("jwtToken");
  localStorage.removeItem("authToken");
  localStorage.removeItem("selectedCompany");
  sessionStorage.removeItem("token");

  if (brand) {
    localStorage.setItem("brand", brand);
  }
};

export const clearAuthExpiredGuard = () => {
  sessionStorage.removeItem(AUTH_EXPIRED_GUARD_KEY);
};

export const isAuthTokenValid = (token) => {
  if (!token) return false;

  try {
    const cleanToken = token.startsWith("Bearer ") ? token.slice(7) : token;
    const decoded = jwtDecode(cleanToken);
    const nowInSeconds = Date.now() / 1000;

    return !decoded.exp || decoded.exp > nowInSeconds;
  } catch (error) {
    return false;
  }
};

export const getLoginPath = () => {
  try {
    return localStorage.getItem("brand") === "cvcrm" ? "/cvcrm" : "/";
  } catch (error) {
    return "/";
  }
};

export const handleExpiredAuthSession = (
  message = "Sua sessão expirou. Faça login novamente para continuar."
) => {
  if (sessionStorage.getItem(AUTH_EXPIRED_GUARD_KEY) === "1") return;

  sessionStorage.setItem(AUTH_EXPIRED_GUARD_KEY, "1");
  clearAuthStorage();
  window.alert(message);
  window.location.replace(getLoginPath());
};

const isLoginRequest = (url = "") => {
  try {
    const parsedUrl = new URL(String(url), window.location.origin);
    return parsedUrl.pathname.toLowerCase().endsWith("/login");
  } catch (error) {
    return String(url).toLowerCase().endsWith("/login");
  }
};

const requestHadAuthHeader = (config = {}) => {
  const headers = config.headers || {};
  return Boolean(headers.Authorization || headers.authorization);
};

export const registerAuthSessionInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || "";

      if (status === 401 && !isLoginRequest(url) && requestHadAuthHeader(error?.config)) {
        handleExpiredAuthSession();
      }

      return Promise.reject(error);
    }
  );
};
